import "./footer.scss";
import { useNavigate } from "react-router-dom";
import { AppDispatch } from "../../../store/store";
import { useDispatch } from "react-redux";
import { setSelectedCheckboxes } from "../../../features/productList/filter/checkboxSlice";
import { FOOTER_LINKS, FOOTER_ROUTES, PRODUCT_TYPE_OPTION } from "../../../constants/footerConst";

const Index = ({
  showTypes,
  setShowTypes,
}: {
  showTypes: boolean;
  setShowTypes: (value: boolean) => void;
}) => {
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();

  const resetCheckboxes = () => {
    dispatch(
      setSelectedCheckboxes({
        brand: [],
        type: [],
        polarized: [],
        frame_materials: [],
        product_shapes: [],
        rim_type: [],
        features: [],
        gender: [],
        price: [],
        sw_color_list: [],
        lens_color: [],
        bridge_size: [],
        weight: [],
        glass_size: [],
        temple_size: [],
        period_use: [],
        pack_of_qty: [],
      })
    );
  };

  const handleNavigate = (path: string) => {
    if (path === FOOTER_ROUTES.PRODUCT_LIST) {
      setShowTypes(!showTypes);
    } else {
      navigate(path);
      setShowTypes(false);
    }
  };

  const handleProductTypeNavigation = (path: string) => {
    setShowTypes(false);
    resetCheckboxes();
    navigate(`/product/list?${path}`);
    localStorage.setItem("product_filter", path);
  };

  return (
    <>
      <div className="d-md-none footer-container">
        <div className="footer-box">
          <div className="d-flex justify-content-between">
            {FOOTER_LINKS.map(({ path, Icon }, index) => (
              <span key={index} onClick={() => handleNavigate(path)}>
                <Icon className="fs-24" />
              </span>
            ))}
            {showTypes && (
              <div className="product-dropdown">
                {PRODUCT_TYPE_OPTION.map((type) => (
                  <button
                    key={type.name}
                    className="dropdown-item"
                    onClick={() => handleProductTypeNavigation(type.path)}
                  >
                    {type.name}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="d-md-none footer-empty-div"></div>
    </>
  );
};

export default Index;
